var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftInfo"},[_c('div',{staticClass:"usdt"},[_vm._v(" usdt ")]),_c('div',{staticClass:"scroll"},_vm._l((_vm.productNowInfo),function(item,index){return _c('div',{key:index,staticClass:"item",style:({
        color:
          item.BasicPrice - item.Price > 0
            ? _vm.basicConfig.FallColour
            : _vm.basicConfig.RiseColour
      }),on:{"click":function($event){return _vm.handleClick(index)}}},[_c('span',[_vm._v(" "+_vm._s(item.EnglishName))]),_c('span',[_vm._v(_vm._s(item.Price))]),_c('span',[_vm._v(_vm._s(_vm.getRole(item))+"%")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }